<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Logs </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              fab
              @click="getLogs()"
              :disabled="refreshDisabled"
              color="secondary"
              :loading="refreshing"
              v-if="selectedLog"
              small
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="loaded">
            <v-row>
              <v-col>
                <v-select
                  :items="logFiles"
                  placeholder="Logfile"
                  v-model="selectedLog"
                  item-value="filename"
                  item-text="date"
                  :prepend-icon="'mdi-file'"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="selectedLog">
              <v-col>
                <pre>{{ logs }}</pre>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  name: "LogsView",
  data() {
    return {
      loaded: false,
      error: null,
      refreshing: false,
      refreshDisabled: false,
      logs: " ",
      logFiles: [],
      selectedLog: null,
      interval: undefined,
    };
  },
  mounted() {
    this.loadData();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    loadData() {
      this.loaded = false;
      axios.get("/api/v1/logs/list").then((response) => {
        this.logFiles = response.data;
        this.loaded = true;
        if (this.logFiles.length > 0) {
          this.selectedLog = this.logFiles[0].filename;
        }
      });
    },
    getLogs() {
      let that = this;
      if (!this.selectedLog) {
        return;
      }
      this.refreshing = true;
      axios.get(`/api/v1/logs/${this.selectedLog}`).then((response) => {
        that.logs = response.data;
        that.refreshing = false;
      });
    },
  },
  watch: {
    selectedLog() {
      this.getLogs();
      // if the user selects the latest log enable auto refresh otherwise disable
      if (this.selectedLog === this.logFiles[0].filename) {
        this.refreshDisabled = false;
        this.interval = setInterval(() => {
          this.getLogs();
        }, 10000);
      } else {
        this.refreshDisabled = true;
        clearInterval(this.interval);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
pre {
  background-color: #232323;
  padding: 10px;
}
</style>
